import { RestrictToHorizontalAxis } from "@dnd-kit/abstract/modifiers";
import { useSortable } from "@dnd-kit/react/sortable";
import type { ImageStripItem } from "./ImageStripItem";
import { ImageStripTile } from "./ImageStripTile";

const HORIZONTAL_MODIFIERS = [RestrictToHorizontalAxis];

export function SortableImageStripTile({
    image,
    index,
    isCover,
    showActions,
    busy,
    onMoveToFirst,
    onRemove,
}: {
    image: ImageStripItem;
    index: number;
    isCover: boolean;
    showActions: boolean;
    busy: boolean;
    onMoveToFirst?: () => void;
    onRemove: () => void;
}) {
    const { ref, isDragging, isDropTarget } = useSortable({
        id: image.id,
        index,
        modifiers: HORIZONTAL_MODIFIERS,
        transition: { idle: true },
    });

    return (
        <ImageStripTile
            tileRef={ref}
            image={image}
            isCover={isCover}
            isDragging={isDragging}
            isDropTarget={isDropTarget}
            sortable
            showActions={showActions}
            busy={busy}
            onMoveToFirst={onMoveToFirst}
            onRemove={onRemove}
        />
    );
}
